import { useEffect, useRef } from 'react';

import Heading from 'shopper/components/Heading';

import useMediaQuery from 'hooks/useMediaQuery';

import placeholder from 'lib/placeholder';

import PuzzleCard from './PuzzleCard';

import APP from 'constants/app';

const CASES = [
  {
    clicks: 32,
    companyName: 'Samsung',
    ctrPercent: 38,
    epoch: 'Lançamento S24 Jan/2024',
    logoName: 'samsung.svg',
    pageViews: 84,
  },
  {
    clicks: 40,
    companyName: 'Stanley',
    ctrPercent: 40,
    epoch: 'Esquenta BF Nov/2022',
    logoName: 'stanley.svg',
    pageViews: 99,
  },
  {
    clicks: 7,
    companyName: 'Insider',
    ctrPercent: 25,
    epoch: 'Dia dos Pais Ago/2023',
    logoName: 'insider.svg',
    pageViews: 28,
  },
];
const ACCENT_COLOR_BY_INDEX = {
  0: 'highlight',
  1: 'info',
  2: 'secondary',
};

const PartnerCases = () => {
  const { isLg } = useMediaQuery();
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (!isLg) {
      const width = wrapperRef.current.clientWidth;
      const threshold = wrapperRef.current.children[0].clientWidth / 1.5;
      const middle = (width + threshold) / 2;

      wrapperRef.current.scrollTo(middle, 0);
    }
  }, [isLg]);

  return (
    <section>
      <Heading className="mb-6 text-center" size="size2">
        {placeholder('titles.ourCases')}
      </Heading>
      <div
        ref={wrapperRef}
        className="flex justify-between overflow-x-auto pl-2 pr-5 md:px-0"
      >
        {CASES.map(
          (
            { clicks, companyName, ctrPercent, epoch, logoName, pageViews },
            i
          ) => (
            <PuzzleCard
              key={logoName}
              accentColor={ACCENT_COLOR_BY_INDEX[i]}
              clicks={clicks}
              companyName={companyName}
              ctrPercent={ctrPercent}
              epoch={epoch}
              logo={`${APP.LOCAL_IMAGE_PATH}/features/commercial-partners/partners/${logoName}`}
              pageViews={pageViews}
            />
          )
        )}
      </div>
    </section>
  );
};

export default PartnerCases;
